import { useGenerateAsyncQuizMe } from './useGenerateAsyncQuizMe';
import { useGenerateAsyncSummarization } from './useGenerateAsyncSummarization';
export const useInteractiveEducationProps = ({
  primaryContentId,
  contentType,
  language,
  lessonContentId,
  interactiveContentTrackingProps
}) => {
  const {
    onAsyncRegenerateQuiz,
    generateQuizError,
    generateQuizLoading
  } = useGenerateAsyncQuizMe({
    primaryContentId,
    contentType,
    language,
    lessonContentId,
    interactiveContentTrackingProps
  });
  const {
    summary,
    correlationId: summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration
  } = useGenerateAsyncSummarization({
    primaryContentId,
    contentType,
    language,
    lessonContentId
  });
  return {
    handleTriggerAsyncQuizGeneration: onAsyncRegenerateQuiz,
    generateQuizError: !!generateQuizError,
    generateQuizLoading,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration: videoDuration !== null && videoDuration !== void 0 ? videoDuration : undefined
  };
};